import { User } from "@models/User";
import { convertIdInObject } from "@util/convert-id-field";
import apiClient from "./apiClient";

interface UserWithId extends Omit<User, "id"> {
    _id: string
}

export const signUp = async (
    email: string,
    password: string,
    firstName: string,
    lastName: string,
    captchaToken: string,
    region?: "au" | "global",
): Promise<User> => {
    try {
        const response = await apiClient.post<UserWithId>("/user/signup", {
            email, password, firstName, lastName, captchaToken, region,
        });
        return convertIdInObject(response.data);
    } catch (error) {
        console.error("Failed to sign up", error);
        throw error;
    }
};

export const verifyEmail = async (userId: string, token: string) => {
    try {
        const response = await apiClient.post("/user/verify-email", { userId, token });
        return response.data;
    } catch (error) {
        console.error("Failed to verify email", error);
        throw error;
    }
};

export const refreshUserData = async (): Promise<User> => {
    try {
        const response = await apiClient.post<UserWithId>("/user/refresh");
        return convertIdInObject(response.data);
    } catch (error) {
        console.error("Failed to refresh user data", error);
        throw error;
    }
};

export const submitAttribution = async (
    userId: string,
    source: string,
    otherText?: string,
): Promise<void> => {
    try {
        await apiClient.post("/user/attribution", {
            userId,
            source,
            otherText,
        });
    } catch (error) {
        console.error("Failed to submit attribution", error);
        throw error;
    }
};
